module.exports = __webpack_public_path__ + "static/img/logo9.01a181ca.png";